//-- Copyright (c) 2021 TMT Insights Group, LLC
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Button, Card, CardContent, Grid } from '@mui/material';
import { selectActiveTitle, selectIsActiveTitleLoading } from '@/redux/selectors/titleV2Selectors';
import TabHeading from '../../_common/Tabs/TabHeading';
import { selectJob } from '@/redux/selectors/jobSelectors';
import { useAppSelector } from '@/redux/hooks';
import TitleDetailMetadataV2 from '@/components/TitleDetail/v2/TitleDetailMetadataV2/TitleDetailMetadataV2';
import TitleDetailSynopsisV2 from '@/components/TitleDetail/v2/TitleDetailMetadataV2/TitleDetailSynopsisV2';
import { buildTitleURL, getTitlePath } from '@/_utils/titleUtils';

const JobTabTitleOverviewV2 = () => {
  const isActiveTitleLoading = useAppSelector(selectIsActiveTitleLoading);
  const job = useAppSelector(selectJob);
  // We get `title` from the store, and not from the `job.title`, for a reason.
  //  `title` entity from the store is loaded from the dedicated Title Details endpoint and its `lineage` property
  //  is properly parsed.
  const title = useAppSelector(selectActiveTitle);
  const version = job?.version || {};

  const buildTitleUrl = () => {
    // A&E specific case
    if (version.program_id) {
      return buildTitleURL({
        path: [version.program_id],
        ...(version.external_id ? { version: version.external_id } : {})
      });
    }

    // if title is not loaded yet
    if (!title) {
      return '';
    }

    return buildTitleURL({
      path: getTitlePath(title),
      version: version.id
    });
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <Card elevation={0}>
          <CardContent>
            <Grid container justifyContent="space-between" alignItems="center" sx={{ position: 'relative' }}>
              <TabHeading icon={<PolarisIcon icon="info" />}>Metadata</TabHeading>
              <TitleRecordButton
                variant="text"
                color="default"
                href={buildTitleUrl()}
                // @ts-expect-error: MUI's Button component doesn't allow `target` prop. But nonetheless it works as expected and <a> tag receives `target` attribute
                target="_blank"
                rel="noopener noreferrer"
                endIcon={<PolarisIcon icon="external_link" style={{ color: 'var(--primary-main)' }} height={15} />}
                disabled={isActiveTitleLoading}
              >
                View Title Record
              </TitleRecordButton>
            </Grid>
            <TitleDetailMetadataV2 disableDropdownOffset />
            <TitleDetailSynopsisV2 />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default JobTabTitleOverviewV2;

const TitleRecordButton = styled(Button)`
  position: absolute;
  font-size: 1rem;
  right: 0;
  top: ${({ theme }) => theme.spacing(-1)};
`;
